import { Instance } from 'mobx-state-tree';
import { ShopifyConfigurationDtoModelBase } from './ShopifyConfigurationDtoModel.base';

/* The TypeScript type of an instance of ShopifyConfigurationDtoModel */
export interface ShopifyConfigurationDtoModelType extends Instance<typeof ShopifyConfigurationDtoModel.Type> {}

/* A graphql query fragment builders for ShopifyConfigurationDtoModel */
export { selectFromShopifyConfigurationDto, shopifyConfigurationDtoModelPrimitives, ShopifyConfigurationDtoModelSelector } from './ShopifyConfigurationDtoModel.base';

/**
 * ShopifyConfigurationDtoModel
 */
export const ShopifyConfigurationDtoModel = ShopifyConfigurationDtoModelBase;
